module.exports = __webpack_public_path__ + "static/img/4505_phase_function_Paper_PointsHejduk_Prediction.ba1fcb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4505_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EfsJ
// module chunks = 0